var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCategorySandwich(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_465_8386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.9 96.3586C148.24 95.1436 149.023 91.908 147.093 89.7515L67.6847 1.00064C66.1777 -0.683775 63.8197 -0.797893 62.1615 0.295637L43.4894 11.3765C42.5221 11.8815 26.0465 90.9456 25.0083 102.984C24.8156 105.219 26.3915 107.217 28.61 107.551C41.7553 109.531 59.8356 109.103 79.3459 109.103C96.9612 109.103 112.777 109.755 125.426 108.106C126.108 108.017 126.713 107.779 127.228 107.439L145.9 96.3586Z",
    fill: "url(#paint0_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.092 89.7511L133.31 74.3467L116.381 91.2752L127.204 107.453C127.211 107.448 127.22 107.444 127.227 107.439L145.899 96.3585C148.239 95.1435 149.022 91.9079 147.092 89.7511Z",
    fill: "url(#paint1_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4022 9.63031C39.0637 22.3309 118.436 111.942 132.775 99.2421C135.247 97.0524 134.932 92.575 132.646 86.7306C131.815 84.6077 131.462 82.2841 131.663 79.9018L131.684 79.6462C132.121 74.4662 129.467 69.8774 124.887 67.8947L124.883 67.8933C120.971 66.1997 118.415 62.5818 118.065 58.2415L118.032 57.8285C117.646 53.043 114.55 49.1912 109.995 47.8285L109.647 47.7244C105.464 46.473 102.485 43.1103 101.747 38.8065L101.685 38.4459C100.882 33.7597 97.4313 30.2221 92.7269 29.2618L92.2348 29.1612C87.9925 28.295 84.7375 25.3227 83.5663 21.2453C82.1934 16.4662 77.9869 13.2724 72.8145 13.0818L72.4666 13.0688C70.0775 12.9809 67.8137 12.3491 65.8066 11.2685C60.2807 8.29413 55.8742 7.4406 53.4022 9.63031Z",
    fill: "url(#paint2_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.647 86.7312C131.814 84.6071 131.463 82.283 131.663 79.9018L131.684 79.645C132.119 74.4671 129.466 69.878 124.888 67.8944H124.882C120.972 66.2 118.415 62.5812 118.064 58.2409L118.031 57.83C117.645 53.0438 114.551 49.19 109.994 47.828L109.648 47.7253C105.465 46.4741 102.484 43.1094 101.746 38.8068L101.684 38.4474C101.181 35.5071 99.6352 33.0206 97.3923 31.3397C99.1732 36.3421 98.0626 42.1418 94.0599 46.1441L79.4973 60.7068C99.8858 84.4541 125.262 105.898 132.777 99.2412C135.246 97.0524 134.933 92.5741 132.647 86.7312Z",
    fill: "url(#paint3_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5254 36.9255C72.6618 36.9255 78.4469 31.1403 78.4469 24.004C78.4469 16.8677 72.6618 11.0825 65.5254 11.0825C58.3891 11.0825 52.6039 16.8677 52.6039 24.004C52.6039 31.1403 58.3891 36.9255 65.5254 36.9255Z",
    fill: "url(#paint4_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.392 81.3302C114.528 81.3302 120.313 75.5451 120.313 68.4088C120.313 61.2724 114.528 55.4873 107.392 55.4873C100.255 55.4873 94.4701 61.2724 94.4701 68.4088C94.4701 75.5451 100.255 81.3302 107.392 81.3302Z",
    fill: "url(#paint5_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.343 67.7138C124.803 62.1738 115.821 62.1738 110.281 67.7138C104.741 73.2538 104.741 82.2362 110.281 87.7762C115.821 93.3162 124.803 93.3162 130.343 87.7762C135.883 82.2362 135.884 73.2538 130.343 67.7138ZM113.942 84.115C110.425 80.5974 110.425 74.8927 113.942 71.375C117.46 67.8574 123.163 67.8588 126.681 71.3765C130.198 74.8941 130.2 80.5977 126.682 84.115C123.165 87.6327 117.46 87.6327 113.942 84.115Z",
    fill: "url(#paint6_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.968 86.089C116.576 90.6967 124.049 90.6967 128.656 86.089C133.265 81.4799 133.264 74.0085 128.656 69.4008C124.047 64.7917 116.577 64.7917 111.968 69.4008C107.36 74.0085 107.359 81.4799 111.968 86.089ZM126.682 71.3749C130.2 74.8926 130.2 80.5973 126.682 84.1149C123.165 87.6326 117.461 87.6311 113.944 84.1135C110.426 80.5958 110.425 74.8923 113.942 71.3749C117.46 67.8573 123.165 67.8573 126.682 71.3749Z",
    fill: "url(#paint7_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0608 26.0809C88.5208 20.5409 79.5384 20.5409 73.9984 26.0809C68.4584 31.6209 68.4584 40.6033 73.9984 46.1433C79.5384 51.6833 88.5208 51.6833 94.0608 46.1433C99.6008 40.6033 99.6008 31.6209 94.0608 26.0809ZM77.6593 42.4821C74.1417 38.9644 74.1417 33.2597 77.6593 29.7421C81.177 26.2244 86.8805 26.2259 90.3979 29.7435C93.9152 33.2612 93.917 38.9647 90.3993 42.4824C86.882 45.9997 81.177 45.9997 77.6593 42.4821Z",
    fill: "url(#paint8_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6851 44.4561C80.2928 49.0638 87.7657 49.0638 92.3733 44.4561C96.9825 39.847 96.981 32.3755 92.3733 27.7679C87.7642 23.1588 80.2942 23.1588 75.6851 27.7679C71.0775 32.3755 71.076 39.847 75.6851 44.4561ZM90.3995 29.742C93.9172 33.2596 93.9172 38.9643 90.3995 42.482C86.8819 45.9996 81.1783 45.9982 77.661 42.4805C74.1433 38.9629 74.1419 33.2593 77.6595 29.742C81.1769 26.2243 86.8819 26.2243 90.3995 29.742Z",
    fill: "url(#paint9_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.777 93.9103L125.813 92.0518C128.761 89.3623 129.174 84.6162 126.779 80.5223C121.418 71.3606 111.937 58.8785 100.167 45.9809C88.3981 33.0832 76.8337 22.5017 68.1999 16.327C64.3416 13.5679 59.5778 13.5465 56.6304 16.2359L54.5937 18.0944C53.1325 19.4276 53.6328 22.085 55.5966 23.36C64.4293 29.0938 77.2687 40.5735 90.3651 54.9256C103.462 69.2776 113.721 83.1115 118.625 92.4309C119.715 94.5029 122.315 95.2438 123.777 93.9103Z",
    fill: "url(#paint10_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1119 31.572C70.5834 38.0614 75.8993 43.3776 82.3887 46.8488C83.4702 47.4273 84.7778 46.6438 84.7778 45.4173V33.5709C84.7778 31.1473 82.8131 29.1826 80.3896 29.1826H68.5434C67.3169 29.1829 66.5334 30.4906 67.1119 31.572Z",
    fill: "url(#paint11_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0417 12.7182C43.7196 19.2038 123.092 108.815 130.415 102.33C131.677 101.211 130.361 97.6208 127.282 92.4785C126.163 90.6105 125.343 88.7008 124.91 86.88L124.863 86.6847C123.922 82.7249 120.881 78.4788 117.076 75.8102L117.073 75.8082C113.822 73.5288 111.088 70.0682 109.78 66.5767L109.655 66.2446C108.213 62.3949 105.031 58.6199 101.394 56.4441L101.116 56.2779C97.7755 54.2796 94.7964 50.9167 93.2158 47.3596L93.0834 47.0617C91.3623 43.1885 87.9987 39.5741 84.3511 37.6776L83.9696 37.4791C80.6802 35.7688 77.5958 32.6452 75.7552 29.1605C73.5981 25.0761 69.769 21.5476 65.969 20.1417L65.7134 20.047C63.9581 19.3976 62.1617 18.352 60.4426 17.0164C55.7096 13.3399 52.3043 11.5999 51.0417 12.7182Z",
    fill: "url(#paint12_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.644 101.852L127.228 107.438C126.712 107.779 126.107 108.016 125.426 108.106C112.775 109.754 96.9604 105.29 79.3451 105.29C59.8354 105.29 41.7548 109.53 28.6098 107.552C26.391 107.217 24.8154 105.219 25.0075 102.984C26.0451 90.9447 42.5228 11.8817 43.4901 11.3761L51.4598 6.64673L136.644 101.852Z",
    fill: "url(#paint13_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.644 101.852L127.228 107.438C126.712 107.779 126.107 108.016 125.426 108.106C112.775 109.754 96.611 107.139 78.996 107.139C59.4863 107.139 41.7548 109.53 28.6098 107.552C26.391 107.217 24.8154 105.219 25.0075 102.984C26.0451 90.9447 42.5228 11.8817 43.4901 11.3761L51.4598 6.64673L136.644 101.852Z",
    fill: "url(#paint14_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3842 13.96C30.0136 53.0309 50.5963 62.2729 49.5581 74.3114C49.3654 76.5467 26.3907 107.217 28.6092 107.551C41.7545 109.531 59.5966 108.864 79.1069 108.864C96.7219 108.864 112.776 109.755 125.425 108.106C128.818 107.663 130.329 103.604 128.047 101.053L48.6389 12.3029C46.4101 9.81203 42.3181 10.7509 41.3842 13.96Z",
    fill: "url(#paint15_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0072 102.984C24.8146 105.219 26.3905 107.217 28.609 107.551C41.7543 109.531 59.4855 110.744 78.9958 110.744C96.6111 110.744 112.776 109.755 125.425 108.106C128.818 107.663 130.329 103.604 128.047 101.054L107.192 77.745H27.9396C26.3052 89.2353 25.422 98.175 25.0072 102.984Z",
    fill: "url(#paint16_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M53.1112 31.2153C54.3694 31.2153 55.3894 30.1953 55.3894 28.937C55.3894 27.6788 54.3694 26.6588 53.1112 26.6588C51.853 26.6588 50.833 27.6788 50.833 28.937C50.833 30.1953 51.853 31.2153 53.1112 31.2153Z",
    fill: "url(#paint17_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M46.2012 32.9379C47.1945 32.9379 47.9997 32.1326 47.9997 31.1393C47.9997 30.146 47.1945 29.3408 46.2012 29.3408C45.2079 29.3408 44.4026 30.146 44.4026 31.1393C44.4026 32.1326 45.2079 32.9379 46.2012 32.9379Z",
    fill: "url(#paint18_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M51.5909 38.1129C52.1896 38.1129 52.675 37.6276 52.675 37.0288C52.675 36.4301 52.1896 35.9447 51.5909 35.9447C50.9921 35.9447 50.5067 36.4301 50.5067 37.0288C50.5067 37.6276 50.9921 38.1129 51.5909 38.1129Z",
    fill: "url(#paint19_linear_465_8386)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M37.7355 94.8267C38.9938 94.8267 40.0138 93.8067 40.0138 92.5485C40.0138 91.2903 38.9938 90.2703 37.7355 90.2703C36.4773 90.2703 35.4573 91.2903 35.4573 92.5485C35.4573 93.8067 36.4773 94.8267 37.7355 94.8267Z",
    fill: "url(#paint20_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M38.146 101.588C39.1393 101.588 39.9445 100.782 39.9445 99.7891C39.9445 98.7958 39.1393 97.9906 38.146 97.9906C37.1527 97.9906 36.3475 98.7958 36.3475 99.7891C36.3475 100.782 37.1527 101.588 38.146 101.588Z",
    fill: "url(#paint21_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M45.1929 97.1221C45.7917 97.1221 46.277 96.6367 46.277 96.038C46.277 95.4392 45.7917 94.9539 45.1929 94.9539C44.5942 94.9539 44.1088 95.4392 44.1088 96.038C44.1088 96.6367 44.5942 97.1221 45.1929 97.1221Z",
    fill: "url(#paint22_linear_465_8386)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M61.7513 39.1868C62.6809 39.1868 63.4345 38.4332 63.4345 37.5035C63.4345 36.5739 62.6809 35.8203 61.7513 35.8203C60.8217 35.8203 60.0681 36.5739 60.0681 37.5035C60.0681 38.4332 60.8217 39.1868 61.7513 39.1868Z",
    fill: "url(#paint23_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M57.1342 36.1121C57.8681 36.1121 58.463 35.5172 58.463 34.7833C58.463 34.0494 57.8681 33.4545 57.1342 33.4545C56.4003 33.4545 55.8054 34.0494 55.8054 34.7833C55.8054 35.5172 56.4003 36.1121 57.1342 36.1121Z",
    fill: "url(#paint24_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M56.5461 41.4538C56.9886 41.4538 57.3473 41.0951 57.3473 40.6526C57.3473 40.2101 56.9886 39.8514 56.5461 39.8514C56.1036 39.8514 55.7449 40.2101 55.7449 40.6526C55.7449 41.0951 56.1036 41.4538 56.5461 41.4538Z",
    fill: "url(#paint25_linear_465_8386)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M100.377 98.9676C101.306 98.9676 102.06 98.2139 102.06 97.2843C102.06 96.3547 101.306 95.6011 100.377 95.6011C99.447 95.6011 98.6934 96.3547 98.6934 97.2843C98.6934 98.2139 99.447 98.9676 100.377 98.9676Z",
    fill: "url(#paint26_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M95.7596 95.8929C96.4935 95.8929 97.0884 95.2979 97.0884 94.5641C97.0884 93.8302 96.4935 93.2352 95.7596 93.2352C95.0257 93.2352 94.4308 93.8302 94.4308 94.5641C94.4308 95.2979 95.0257 95.8929 95.7596 95.8929Z",
    fill: "url(#paint27_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M95.1715 101.235C95.614 101.235 95.9727 100.876 95.9727 100.434C95.9727 99.9913 95.614 99.6326 95.1715 99.6326C94.729 99.6326 94.3703 99.9913 94.3703 100.434C94.3703 100.876 94.729 101.235 95.1715 101.235Z",
    fill: "url(#paint28_linear_465_8386)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M111.644 61.7348C111.074 61.9307 110.772 62.5507 110.968 63.1198C111.164 63.6889 111.784 63.9916 112.353 63.7957C112.922 63.5998 113.224 62.9798 113.029 62.4107C112.833 61.8416 112.213 61.5389 111.644 61.7348Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.558 63.8571C114.712 64.3065 115.202 64.5453 115.651 64.3906C116.1 64.2359 116.339 63.7465 116.185 63.2971C116.03 62.8477 115.54 62.6088 115.091 62.7635C114.642 62.9182 114.403 63.4077 114.558 63.8571Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.93 59.9342C117.023 60.2051 117.318 60.3492 117.589 60.256C117.86 60.1627 118.004 59.8677 117.911 59.5968C117.817 59.326 117.522 59.1818 117.252 59.2751C116.981 59.3683 116.837 59.6633 116.93 59.9342Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.127 52.812C109.555 53.2353 110.245 53.2315 110.668 52.8035C111.091 52.3756 111.087 51.6856 110.659 51.2623C110.231 50.8391 109.541 50.8429 109.118 51.2709C108.695 51.6988 108.699 52.3888 109.127 52.812Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0137 47.187C98.3516 47.5211 98.8963 47.5182 99.2304 47.1803C99.5645 46.8423 99.5616 46.2976 99.2237 45.9635C98.8857 45.6294 98.341 45.6323 98.0069 45.9703C97.6728 46.3082 97.676 46.8529 98.0137 47.187Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.076 52.4063C104.28 52.6077 104.608 52.606 104.81 52.4021C105.011 52.1983 105.01 51.8701 104.806 51.6686C104.602 51.4671 104.274 51.4689 104.072 51.6727C103.871 51.8763 103.873 52.2048 104.076 52.4063Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.431 58.6924C113.815 58.9162 114.309 58.7865 114.533 58.4021C114.756 58.018 114.627 57.5248 114.242 57.3009C113.858 57.0771 113.365 57.2068 113.141 57.5912C112.917 57.9753 113.047 58.4683 113.431 58.6924Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.238 59.7194C111.541 59.8961 111.93 59.7935 112.107 59.4903C112.284 59.187 112.181 58.7976 111.878 58.6209C111.575 58.4441 111.185 58.5467 111.009 58.85C110.832 59.1532 110.934 59.5426 111.238 59.7194Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.976 60.5753C113.793 60.4689 113.558 60.5306 113.452 60.7136C113.345 60.8965 113.407 61.1312 113.59 61.2377C113.773 61.3442 114.008 61.2824 114.114 61.0994C114.221 60.9168 114.158 60.6821 113.976 60.5753Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6311 41.9086C89.0619 42.1045 88.7593 42.7245 88.9552 43.2936C89.1511 43.8627 89.7711 44.1654 90.3402 43.9695C90.9093 43.7736 91.2119 43.1536 91.0161 42.5845C90.8202 42.0157 90.2002 41.713 89.6311 41.9086Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8855 51.2274C100.04 51.6768 100.53 51.9157 100.979 51.761C101.428 51.6063 101.667 51.1168 101.513 50.6674C101.358 50.218 100.868 49.9792 100.419 50.1339C99.9699 50.2886 99.7308 50.778 99.8855 51.2274Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6477 43.0511C97.7409 43.322 98.0359 43.4661 98.3068 43.3729C98.5777 43.2797 98.7218 42.9847 98.6286 42.7138C98.5353 42.4429 98.2403 42.2988 97.9695 42.392C97.6986 42.4853 97.5545 42.7805 97.6477 43.0511Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2985 36.7815C86.7265 37.2048 87.4165 37.2009 87.8397 36.773C88.263 36.345 88.2591 35.655 87.8312 35.2318C87.4032 34.8086 86.7132 34.8124 86.29 35.2403C85.8668 35.6683 85.8706 36.3583 86.2985 36.7815Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3934 37.9266C85.0593 38.2645 85.0623 38.8092 85.4002 39.1433C85.7382 39.4775 86.2829 39.4745 86.617 39.1366C86.9511 38.7986 86.9481 38.2539 86.6102 37.9198C86.2723 37.5857 85.7276 37.5889 85.3934 37.9266Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1173 40.9622C87.3211 41.1636 87.6493 41.1619 87.8508 40.9581C88.0523 40.7545 88.0505 40.426 87.8467 40.2245C87.6429 40.023 87.3146 40.0248 87.1132 40.2286C86.912 40.4325 86.9138 40.761 87.1173 40.9622Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6913 38.6709C96.0755 38.8947 96.5687 38.765 96.7925 38.3806C97.0163 37.9965 96.8866 37.5033 96.5022 37.2794C96.1181 37.0556 95.6249 37.1853 95.401 37.5697C95.1772 37.9541 95.3072 38.4471 95.6913 38.6709Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2255 39.8933C89.5288 40.0701 89.9182 39.9674 90.095 39.6642C90.2717 39.361 90.1691 38.9716 89.8658 38.7948C89.5626 38.618 89.1732 38.7207 88.9964 39.0239C88.8197 39.3274 88.922 39.7166 89.2255 39.8933Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9626 40.7495C91.7797 40.6431 91.545 40.7048 91.4385 40.8878C91.332 41.0707 91.3938 41.3054 91.5768 41.4119C91.7597 41.5183 91.9944 41.4566 92.1009 41.2736C92.2073 41.0907 92.1456 40.856 91.9626 40.7495Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.384 13.96C30.0134 53.0309 26.0455 90.9453 25.0072 102.984C24.8146 105.219 26.3905 107.216 28.609 107.551C41.7543 109.53 59.4855 110.744 78.9958 110.744C96.6108 110.744 112.776 109.754 125.425 108.105C128.818 107.663 130.329 103.604 128.047 101.053L48.6387 12.3029C46.4099 9.81203 42.3178 10.7509 41.384 13.96Z",
    fill: "url(#paint29_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.679 135.198C126.019 133.983 126.803 130.747 124.873 128.591L45.4643 39.84C43.9573 38.1556 41.5993 38.0415 39.9411 39.135L21.269 50.2159C20.3017 50.7209 19.5132 51.6021 19.1643 52.7997C7.79375 91.8706 3.8258 129.785 2.78757 141.823C2.59492 144.059 4.1708 146.056 6.38933 146.39C19.5346 148.37 37.2661 149.584 56.7761 149.584C74.3914 149.584 90.5561 148.594 103.205 146.945C103.888 146.856 104.493 146.619 105.007 146.279L123.679 135.198Z",
    fill: "url(#paint30_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.873 128.591L111.09 113.186L94.1616 130.115L104.985 146.292C104.992 146.287 105 146.284 105.008 146.279L123.68 135.198C126.02 133.983 126.803 130.747 124.873 128.591Z",
    fill: "url(#paint31_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1827 48.4697C16.8438 61.1703 96.2168 150.782 110.555 138.081C113.028 135.892 112.712 131.414 110.426 125.57C109.596 123.447 109.242 121.123 109.443 118.741L109.464 118.486C109.901 113.306 107.247 108.717 102.667 106.734L102.664 106.733C98.7509 105.039 96.195 101.421 95.8453 97.0808L95.8121 96.6679C95.4262 91.8823 92.3306 88.0306 87.7756 86.6679L87.4277 86.5638C83.2442 85.3123 80.265 81.9497 79.5271 77.6458L79.4653 77.2853C78.6618 72.5991 75.2115 69.0614 70.5071 68.1011L70.015 68.0005C65.7727 67.1344 62.5177 64.162 61.3465 60.0847C59.9736 55.3055 55.7671 52.1117 50.5947 51.9211L50.2468 51.9082C47.8577 51.8203 45.5939 51.1885 43.5868 50.1079C38.0609 47.1335 33.6547 46.28 31.1827 48.4697Z",
    fill: "url(#paint32_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.427 125.571C109.595 123.446 109.244 121.122 109.444 118.741L109.465 118.484C109.9 113.306 107.246 108.717 102.668 106.734H102.663C98.7523 105.039 96.1959 101.421 95.8444 97.0803L95.812 96.6694C95.4256 91.8832 92.3312 88.0294 87.7747 86.6673L87.4288 86.5647C83.2453 85.3135 80.2644 81.9488 79.5264 77.6461L79.4644 77.2867C78.9617 74.3464 77.4159 71.86 75.1729 70.1791C76.9538 75.1814 75.8432 80.9811 71.8406 84.9835L57.2779 99.5461C77.6664 123.293 103.042 144.737 110.557 138.081C113.027 135.892 112.714 131.413 110.427 125.571Z",
    fill: "url(#paint33_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3057 75.7649C50.4421 75.7649 56.2272 69.9798 56.2272 62.8435C56.2272 55.7071 50.4421 49.922 43.3057 49.922C36.1694 49.922 30.3843 55.7071 30.3843 62.8435C30.3843 69.9798 36.1694 75.7649 43.3057 75.7649Z",
    fill: "url(#paint34_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1718 120.17C92.3082 120.17 98.0933 114.385 98.0933 107.248C98.0933 100.112 92.3082 94.3268 85.1718 94.3268C78.0355 94.3268 72.2504 100.112 72.2504 107.248C72.2504 114.385 78.0355 120.17 85.1718 120.17Z",
    fill: "url(#paint35_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.124 106.553C102.584 101.013 93.6017 101.013 88.0616 106.553C82.5216 112.093 82.5216 121.076 88.0616 126.616C93.6017 132.156 102.584 132.156 108.124 126.616C113.664 121.076 113.664 112.093 108.124 106.553ZM91.7228 122.954C88.2052 119.437 88.2052 113.732 91.7228 110.214C95.2405 106.697 100.944 106.698 104.461 110.216C107.979 113.733 107.98 119.437 104.463 122.954C100.945 126.472 95.2405 126.472 91.7228 122.954Z",
    fill: "url(#paint36_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7487 124.929C94.3563 129.536 101.829 129.536 106.437 124.929C111.046 120.319 111.045 112.848 106.437 108.24C101.828 103.631 94.3578 103.631 89.7487 108.24C85.141 112.848 85.1396 120.319 89.7487 124.929ZM104.463 110.214C107.98 113.732 107.98 119.437 104.463 122.954C100.945 126.472 95.2416 126.471 91.7243 122.953C88.2069 119.435 88.2052 113.732 91.7228 110.214C95.2404 106.697 100.945 106.697 104.463 110.214Z",
    fill: "url(#paint37_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8411 64.9204C66.3011 59.3804 57.3188 59.3804 51.7788 64.9204C46.2388 70.4604 46.2388 79.4427 51.7788 84.9827C57.3188 90.5227 66.3011 90.5227 71.8411 84.9827C77.3811 79.4427 77.3811 70.4604 71.8411 64.9204ZM55.4399 81.3215C51.9223 77.8039 51.9223 72.0992 55.4399 68.5816C58.9576 65.0639 64.6611 65.0654 68.1785 68.583C71.6961 72.1007 71.6976 77.8042 68.1799 81.3218C64.6623 84.8392 58.9576 84.8392 55.4399 81.3215Z",
    fill: "url(#paint38_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4657 83.2956C58.0734 87.9032 65.5463 87.9032 70.154 83.2956C74.7631 78.6865 74.7616 71.215 70.154 66.6074C65.5448 61.9982 58.0748 61.9982 53.4657 66.6074C48.8581 71.215 48.8566 78.6865 53.4657 83.2956ZM68.1798 68.5815C71.6975 72.0991 71.6975 77.8038 68.1798 81.3215C64.6622 84.8391 58.9587 84.8376 55.4413 81.32C51.9237 77.8024 51.9222 72.0988 55.4398 68.5815C58.9575 65.0638 64.6625 65.0638 68.1798 68.5815Z",
    fill: "url(#paint39_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.557 132.75L103.594 130.891C106.541 128.202 106.955 123.456 104.56 119.362C99.199 110.2 89.7176 97.718 77.9481 84.8203C66.1787 71.9227 54.6143 61.3412 45.9805 55.1665C42.1223 52.4074 37.3584 52.3859 34.4111 55.0756L32.3743 56.9341C30.9131 58.2674 31.4134 60.9247 33.3773 62.1997C42.2099 67.9335 55.0493 79.4132 68.1458 93.7653C81.2423 108.117 91.502 121.951 96.4055 131.271C97.4955 133.342 100.096 134.083 101.557 132.75Z",
    fill: "url(#paint40_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6819 76.4042C70.251 76.2083 70.5536 75.5883 70.3578 75.0192C70.1619 74.4501 69.5419 74.1474 68.9728 74.3433C68.4036 74.5392 68.101 75.1592 68.2969 75.7283C68.4925 76.2974 69.1128 76.6001 69.6819 76.4042Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7678 74.2818C66.6131 73.8324 66.1237 73.5936 65.6743 73.7483C65.2249 73.903 64.986 74.3924 65.1408 74.8418C65.2955 75.2912 65.7849 75.53 66.2343 75.3753C66.6837 75.2206 66.9225 74.7312 66.7678 74.2818Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3958 78.2048C64.3026 77.9339 64.0076 77.7897 63.7367 77.883C63.4658 77.9762 63.3217 78.2712 63.4149 78.5421C63.5082 78.813 63.8032 78.9571 64.0741 78.8639C64.3449 78.7709 64.4891 78.4756 64.3958 78.2048Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1989 85.3268C71.771 84.9036 71.081 84.9074 70.6578 85.3353C70.2345 85.7633 70.2383 86.4532 70.6663 86.8765C71.0942 87.2997 71.7842 87.2959 72.2075 86.868C72.631 86.44 72.6272 85.75 72.1989 85.3268Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.312 90.9518C82.974 90.6177 82.4293 90.6206 82.0952 90.9585C81.7611 91.2965 81.764 91.8412 82.102 92.1753C82.4399 92.5094 82.9846 92.5065 83.3187 92.1685C83.6529 91.8306 83.6499 91.2859 83.312 90.9518Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.249 85.7329C77.0452 85.5315 76.717 85.5332 76.5155 85.7371C76.314 85.9409 76.3158 86.2691 76.5196 86.4706C76.7234 86.6721 77.0517 86.6703 77.2531 86.4665C77.4546 86.2627 77.4529 85.9344 77.249 85.7329Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8938 79.4466C67.5097 79.2227 67.0165 79.3524 66.7927 79.7369C66.5688 80.121 66.6986 80.6142 67.083 80.838C67.4671 81.0619 67.9603 80.9322 68.1841 80.5477C68.408 80.1636 68.278 79.6707 67.8938 79.4466Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0882 78.4194C69.785 78.2427 69.3956 78.3453 69.2188 78.6486C69.042 78.9518 69.1447 79.3412 69.4479 79.518C69.7511 79.6947 70.1406 79.5921 70.3173 79.2888C70.4941 78.9856 70.3914 78.5965 70.0882 78.4194Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.35 77.5636C67.5329 77.6701 67.7676 77.6083 67.8741 77.4254C67.9806 77.2424 67.9188 77.0077 67.7359 76.9013C67.5529 76.7948 67.3182 76.8566 67.2117 77.0395C67.1053 77.2224 67.167 77.4571 67.35 77.5636Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6941 96.2304C92.2632 96.0345 92.5658 95.4145 92.3699 94.8454C92.1741 94.2762 91.5541 93.9736 90.985 94.1695C90.4158 94.3654 90.1132 94.9854 90.3091 95.5545C90.505 96.1236 91.125 96.4262 91.6941 96.2304Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4406 86.9116C81.2859 86.4622 80.7965 86.2233 80.347 86.378C79.8976 86.5327 79.6588 87.0222 79.8135 87.4716C79.9682 87.921 80.4576 88.1598 80.907 88.0051C81.3562 87.8504 81.595 87.361 81.4406 86.9116Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.678 95.0877C83.5847 94.8168 83.2897 94.6727 83.0188 94.7659C82.748 94.8592 82.6038 95.1542 82.6971 95.425C82.7903 95.6959 83.0853 95.84 83.3562 95.7468C83.6271 95.6536 83.7712 95.3586 83.678 95.0877Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0268 101.357C94.5989 100.934 93.9089 100.938 93.4856 101.366C93.0624 101.794 93.0662 102.484 93.4942 102.907C93.9221 103.33 94.6121 103.327 95.0353 102.899C95.4586 102.471 95.4548 101.781 95.0268 101.357Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9319 100.212C96.266 99.8744 96.2631 99.3297 95.9251 98.9956C95.5872 98.6615 95.0425 98.6644 94.7084 99.0024C94.3743 99.3403 94.3772 99.885 94.7151 100.219C95.0531 100.553 95.5978 100.55 95.9319 100.212Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2081 97.1768C94.0043 96.9753 93.6761 96.9771 93.4746 97.1809C93.2731 97.3844 93.2749 97.713 93.4787 97.9144C93.6826 98.1159 94.0108 98.1141 94.2123 97.9103C94.4137 97.7065 94.412 97.3783 94.2081 97.1768Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.634 99.468C85.2499 99.2442 84.7567 99.3739 84.5328 99.7583C84.309 100.142 84.4387 100.636 84.8231 100.86C85.2073 101.083 85.7005 100.954 85.9243 100.569C86.1481 100.185 86.0184 99.6919 85.634 99.468Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1007 98.2456C91.7974 98.0688 91.408 98.1715 91.2313 98.4747C91.0545 98.778 91.1571 99.1674 91.4604 99.3441C91.7636 99.5209 92.153 99.4183 92.3298 99.115C92.5065 98.8118 92.4039 98.4224 92.1007 98.2456Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3629 97.3898C89.5458 97.4962 89.7805 97.4345 89.887 97.2515C89.9934 97.0686 89.9317 96.8339 89.7487 96.7274C89.5658 96.621 89.3311 96.6827 89.2246 96.8657C89.1179 97.0483 89.1799 97.283 89.3629 97.3898Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8929 70.4115C48.3644 76.9009 53.6803 82.2168 60.1697 85.6883C61.2511 86.2668 62.5588 85.4833 62.5588 84.2568V72.4103C62.5588 69.9868 60.5941 68.0221 58.1705 68.0221H46.3241C45.0979 68.0224 44.3144 69.33 44.8929 70.4115Z",
    fill: "url(#paint41_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8223 51.5577C21.5002 58.0432 100.873 147.655 108.195 141.169C109.458 140.051 108.141 136.46 105.063 131.318C103.944 129.45 103.123 127.54 102.69 125.719L102.644 125.524C101.703 121.565 98.6617 117.318 94.8561 114.65L94.8532 114.648C91.6023 112.369 88.8685 108.908 87.5602 105.416L87.4358 105.084C85.9935 101.235 82.8111 97.4597 79.1744 95.2838L78.8964 95.1177C75.5561 93.1194 72.577 89.7565 70.9964 86.1994L70.8641 85.9015C69.1429 82.0282 65.7794 78.4138 62.1317 76.5174L61.7502 76.3188C58.4608 74.6085 55.3764 71.485 53.5358 68.0003C51.3788 63.9159 47.5497 60.3874 43.7497 58.9815L43.4941 58.8868C41.7388 58.2374 39.9423 57.1918 38.2232 55.8562C33.4899 52.1794 30.0847 50.4394 28.8223 51.5577Z",
    fill: "url(#paint42_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.425 140.691L105.01 146.278C104.494 146.618 103.888 146.856 103.207 146.945C90.5564 148.594 74.3926 149.583 56.7773 149.583C37.2676 149.583 19.5361 148.369 6.39114 146.391C4.17232 146.056 2.59673 144.059 2.78879 141.824C3.82644 129.784 7.79673 91.87 19.1661 52.7994C19.5147 51.602 20.3038 50.7212 21.2714 50.2159L29.2411 45.4865L114.425 140.691Z",
    fill: "url(#paint43_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.425 140.691L105.01 146.278C104.494 146.618 103.888 146.856 103.207 146.945C90.5564 148.594 74.3926 149.583 56.7773 149.583C37.2676 149.583 19.5361 148.369 6.39114 146.391C4.17232 146.056 2.59673 144.059 2.78879 141.824C3.82644 129.784 8.67909 93.0465 20.0485 53.9759C20.397 52.7785 21.1861 51.8976 22.1538 51.3923L29.2411 45.4865L114.425 140.691Z",
    fill: "url(#paint44_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1653 52.7995C7.79475 91.8703 3.82681 129.785 2.78857 141.823C2.59593 144.058 4.17181 146.056 6.39034 146.39C19.5353 148.37 37.2668 149.584 56.7768 149.584C74.3918 149.584 90.5568 148.594 103.206 146.945C106.599 146.503 108.11 142.443 105.828 139.893L26.4198 51.1424C24.1912 48.6515 20.0992 49.5903 19.1653 52.7995Z",
    fill: "url(#paint45_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.78857 141.823C2.59593 144.058 4.17181 146.056 6.39034 146.39C19.5353 148.37 37.2668 149.584 56.7768 149.584C74.3921 149.584 90.5568 148.594 103.206 146.945C106.599 146.503 108.11 142.443 105.828 139.893L84.973 116.584L7.14475 116.73C5.51004 128.22 3.20328 137.014 2.78857 141.823Z",
    fill: "url(#paint46_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M30.8918 70.0546C32.1501 70.0546 33.1701 69.0346 33.1701 67.7764C33.1701 66.5182 32.1501 65.4982 30.8918 65.4982C29.6336 65.4982 28.6136 66.5182 28.6136 67.7764C28.6136 69.0346 29.6336 70.0546 30.8918 70.0546Z",
    fill: "url(#paint47_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M23.9818 71.7772C24.9751 71.7772 25.7803 70.972 25.7803 69.9787C25.7803 68.9854 24.9751 68.1802 23.9818 68.1802C22.9885 68.1802 22.1833 68.9854 22.1833 69.9787C22.1833 70.972 22.9885 71.7772 23.9818 71.7772Z",
    fill: "url(#paint48_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M29.3712 76.9523C29.9699 76.9523 30.4553 76.4669 30.4553 75.8682C30.4553 75.2694 29.9699 74.7841 29.3712 74.7841C28.7724 74.7841 28.2871 75.2694 28.2871 75.8682C28.2871 76.4669 28.7724 76.9523 29.3712 76.9523Z",
    fill: "url(#paint49_linear_465_8386)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M15.5162 133.666C16.7744 133.666 17.7944 132.646 17.7944 131.388C17.7944 130.13 16.7744 129.11 15.5162 129.11C14.2579 129.11 13.2379 130.13 13.2379 131.388C13.2379 132.646 14.2579 133.666 15.5162 133.666Z",
    fill: "url(#paint50_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M15.9263 140.427C16.9196 140.427 17.7248 139.622 17.7248 138.628C17.7248 137.635 16.9196 136.83 15.9263 136.83C14.933 136.83 14.1278 137.635 14.1278 138.628C14.1278 139.622 14.933 140.427 15.9263 140.427Z",
    fill: "url(#paint51_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M22.9736 135.961C23.5723 135.961 24.0577 135.476 24.0577 134.877C24.0577 134.279 23.5723 133.793 22.9736 133.793C22.3748 133.793 21.8895 134.279 21.8895 134.877C21.8895 135.476 22.3748 135.961 22.9736 135.961Z",
    fill: "url(#paint52_linear_465_8386)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M39.5319 78.0258C40.4615 78.0258 41.2151 77.2722 41.2151 76.3425C41.2151 75.4129 40.4615 74.6593 39.5319 74.6593C38.6023 74.6593 37.8487 75.4129 37.8487 76.3425C37.8487 77.2722 38.6023 78.0258 39.5319 78.0258Z",
    fill: "url(#paint53_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M34.9145 74.9511C35.6484 74.9511 36.2433 74.3562 36.2433 73.6223C36.2433 72.8884 35.6484 72.2935 34.9145 72.2935C34.1806 72.2935 33.5857 72.8884 33.5857 73.6223C33.5857 74.3562 34.1806 74.9511 34.9145 74.9511Z",
    fill: "url(#paint54_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M34.3264 80.2932C34.7689 80.2932 35.1276 79.9345 35.1276 79.492C35.1276 79.0495 34.7689 78.6908 34.3264 78.6908C33.884 78.6908 33.5253 79.0495 33.5253 79.492C33.5253 79.9345 33.884 80.2932 34.3264 80.2932Z",
    fill: "url(#paint55_linear_465_8386)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M78.1573 137.807C79.0869 137.807 79.8405 137.053 79.8405 136.124C79.8405 135.194 79.0869 134.441 78.1573 134.441C77.2277 134.441 76.4741 135.194 76.4741 136.124C76.4741 137.053 77.2277 137.807 78.1573 137.807Z",
    fill: "url(#paint56_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M73.5402 134.732C74.2741 134.732 74.869 134.137 74.869 133.404C74.869 132.67 74.2741 132.075 73.5402 132.075C72.8063 132.075 72.2114 132.67 72.2114 133.404C72.2114 134.137 72.8063 134.732 73.5402 134.732Z",
    fill: "url(#paint57_linear_465_8386)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M72.9518 140.074C73.3943 140.074 73.753 139.715 73.753 139.273C73.753 138.831 73.3943 138.472 72.9518 138.472C72.5093 138.472 72.1506 138.831 72.1506 139.273C72.1506 139.715 72.5093 140.074 72.9518 140.074Z",
    fill: "url(#paint58_linear_465_8386)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_465_8386",
    x1: 107.677,
    y1: 30.3118,
    x2: 86.3268,
    y2: 70.3095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_465_8386",
    x1: 139.913,
    y1: 93.3137,
    x2: 127.481,
    y2: 90.2058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_465_8386",
    x1: 106.247,
    y1: 41.2782,
    x2: 99.8228,
    y2: 47.7021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_465_8386",
    x1: 111.708,
    y1: 65.7856,
    x2: 87.0249,
    y2: 63.6235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#798C00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6542,
    stopColor: "#556100",
    stopOpacity: 0.654
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#464F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_465_8386",
    x1: 67.8995,
    y1: 13.6763,
    x2: 64.2963,
    y2: 29.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_465_8386",
    x1: 109.766,
    y1: 58.0808,
    x2: 106.162,
    y2: 73.7558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_465_8386",
    x1: 124.451,
    y1: 65.471,
    x2: 118.801,
    y2: 81.9591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_465_8386",
    x1: 116.925,
    y1: 87.8093,
    x2: 121.625,
    y2: 74.0942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_465_8386",
    x1: 88.1732,
    y1: 23.8443,
    x2: 82.5237,
    y2: 40.3322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_465_8386",
    x1: 80.6475,
    y1: 46.1827,
    x2: 85.3471,
    y2: 32.4675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_465_8386",
    x1: 99.7765,
    y1: 46.3422,
    x2: 86.7989,
    y2: 58.1816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57C52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1339,
    stopColor: "#A26C4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5155,
    stopColor: "#994336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8174,
    stopColor: "#942A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#922125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_465_8386",
    x1: 75.8478,
    y1: 30.1785,
    x2: 75.8478,
    y2: 47.6679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_465_8386",
    x1: 97.7881,
    y1: 51.1341,
    x2: 92.9796,
    y2: 55.4861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_465_8386",
    x1: 99.2166,
    y1: 39.46,
    x2: 80.3031,
    y2: 74.8926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_465_8386",
    x1: 91.4331,
    y1: 55.2467,
    x2: 81.4292,
    y2: 65.2506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2918,
    stopColor: "#EC2819",
    stopOpacity: 0.292
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8165,
    stopColor: "#CD2727",
    stopOpacity: 0.817
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_465_8386",
    x1: 43.8186,
    y1: 37.2829,
    x2: 88.6807,
    y2: 124.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2061,
    stopColor: "#FBA682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5808,
    stopColor: "#FDA861"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA936"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_465_8386",
    x1: 77.0634,
    y1: 97.6712,
    x2: 77.0634,
    y2: 124.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_465_8386",
    x1: 53.1938,
    y1: 32.1159,
    x2: 53.9461,
    y2: 21.3626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_465_8386",
    x1: 46.3365,
    y1: 33.5889,
    x2: 46.9305,
    y2: 25.0997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_465_8386",
    x1: 51.8001,
    y1: 38.3928,
    x2: 52.158,
    y2: 33.2748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_465_8386",
    x1: 41.6973,
    y1: 93.4912,
    x2: 31.4657,
    y2: 90.0892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_465_8386",
    x1: 41.4196,
    y1: 100.501,
    x2: 33.3423,
    y2: 97.8153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_465_8386",
    x1: 47.4323,
    y1: 96.4024,
    x2: 42.5627,
    y2: 94.7829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_465_8386",
    x1: 60.1892,
    y1: 38.8637,
    x2: 66.4816,
    y2: 33.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_465_8386",
    x1: 56.0005,
    y1: 35.8133,
    x2: 60.968,
    y2: 31.9587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_465_8386",
    x1: 56.0459,
    y1: 41.1881,
    x2: 59.0408,
    y2: 38.8642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_465_8386",
    x1: 98.7904,
    y1: 98.6276,
    x2: 105.083,
    y2: 93.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_465_8386",
    x1: 94.6014,
    y1: 95.577,
    x2: 99.569,
    y2: 91.7224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_465_8386",
    x1: 94.6472,
    y1: 100.952,
    x2: 97.6421,
    y2: 98.6279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_465_8386",
    x1: 83.6767,
    y1: 61.2915,
    x2: 66.3802,
    y2: 81.8309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_465_8386",
    x1: 85.1379,
    y1: 68.9809,
    x2: 63.7879,
    y2: 108.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_465_8386",
    x1: 117.693,
    y1: 132.153,
    x2: 105.262,
    y2: 129.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_465_8386",
    x1: 84.0268,
    y1: 80.1176,
    x2: 77.603,
    y2: 86.5414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_465_8386",
    x1: 89.4885,
    y1: 104.625,
    x2: 64.8053,
    y2: 102.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#798C00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6542,
    stopColor: "#556100",
    stopOpacity: 0.654
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#464F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_465_8386",
    x1: 45.6801,
    y1: 52.5158,
    x2: 42.0766,
    y2: 68.1905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_465_8386",
    x1: 87.5463,
    y1: 96.9203,
    x2: 83.9427,
    y2: 112.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_465_8386",
    x1: 102.235,
    y1: 104.304,
    x2: 96.5848,
    y2: 120.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_465_8386",
    x1: 94.7088,
    y1: 126.643,
    x2: 99.4083,
    y2: 112.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_465_8386",
    x1: 65.9571,
    y1: 62.6778,
    x2: 60.3073,
    y2: 79.1659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_465_8386",
    x1: 58.4314,
    y1: 85.0162,
    x2: 63.131,
    y2: 71.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_465_8386",
    x1: 77.5762,
    y1: 85.206,
    x2: 64.5984,
    y2: 97.0454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57C52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1339,
    stopColor: "#A26C4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5155,
    stopColor: "#994336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8174,
    stopColor: "#942A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#922125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_465_8386",
    x1: 53.6291,
    y1: 69.018,
    x2: 53.6291,
    y2: 86.5074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_465_8386",
    x1: 75.5685,
    y1: 89.9735,
    x2: 70.7602,
    y2: 94.3256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_465_8386",
    x1: 76.6791,
    y1: 78.1291,
    x2: 57.7656,
    y2: 113.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_465_8386",
    x1: 69.6606,
    y1: 94.5323,
    x2: 59.6567,
    y2: 104.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2918,
    stopColor: "#EC2819",
    stopOpacity: 0.292
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8165,
    stopColor: "#CD2727",
    stopOpacity: 0.817
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_465_8386",
    x1: 20.8471,
    y1: 76.5103,
    x2: 65.7092,
    y2: 163.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_465_8386",
    x1: 54.8448,
    y1: 136.511,
    x2: 54.8448,
    y2: 163.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_465_8386",
    x1: 30.977,
    y1: 70.9422,
    x2: 31.7295,
    y2: 60.1887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_465_8386",
    x1: 24.1197,
    y1: 72.4147,
    x2: 24.7137,
    y2: 63.9256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_465_8386",
    x1: 29.583,
    y1: 77.2188,
    x2: 29.941,
    y2: 72.1009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_465_8386",
    x1: 19.5046,
    y1: 132.345,
    x2: 9.27305,
    y2: 128.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_465_8386",
    x1: 19.2271,
    y1: 139.354,
    x2: 11.1496,
    y2: 136.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_465_8386",
    x1: 25.2395,
    y1: 135.256,
    x2: 20.37,
    y2: 133.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_465_8386",
    x1: 37.9722,
    y1: 77.6847,
    x2: 44.2647,
    y2: 72.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_465_8386",
    x1: 33.7835,
    y1: 74.634,
    x2: 38.7511,
    y2: 70.7794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_465_8386",
    x1: 33.829,
    y1: 80.0089,
    x2: 36.8238,
    y2: 77.6849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_465_8386",
    x1: 76.5735,
    y1: 137.449,
    x2: 82.8659,
    y2: 132.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_465_8386",
    x1: 72.3847,
    y1: 134.398,
    x2: 77.352,
    y2: 130.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_465_8386",
    x1: 72.4302,
    y1: 139.773,
    x2: 75.4251,
    y2: 137.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_465_8386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(0.476074 -0.416504)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCategorySandwich);
export default __webpack_public_path__ + "static/media/icon-category-sandwich.b30d5f6f.svg";
export { ForwardRef as ReactComponent };